var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 68,
    viewBox: "0 0 69 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.8357 53C33.1315 44.6875 41.159 38.75 50.4057 39.7317C59.209 40.6658 66.2074 48.0917 66.6507 56.9267C66.7615 59.2542 66.4449 61.4867 65.764 63.5608C65.3524 64.8275 64.1174 65.6667 62.7715 65.6667H15.6167C7.62405 65.6667 1.62955 58.3533 3.19705 50.5158L12.8332 2.33334H31.8332L38.1665 13.4167L24.5974 23.1225L20.7499 18.1667M24.6132 23.1225L31.8332 49.8333",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPower);
export default __webpack_public_path__ + "static/media/power.a7b870e692d011f4277dddacc7461ed3.svg";
export { ForwardRef as ReactComponent };